/*------ CUSTOM GEOLOCATION ------*/

document.addEventListener("DOMContentLoaded", () => {

      setTimeout(function(){

        function handleResponse(json) {
            ip = json.ip;
            country_name = json.country_name;
            country_code2 = json.country_code2;
        }
    
        function escapeRegExp(string){
            return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
         
        /* Define functin to find and replace specified term with replacement string */
        function replaceAll(str, term, replacement) {
          return str.replace(new RegExp(escapeRegExp(term), 'g'), replacement);
        }

        //if (window.location.href.indexOf("en-us") > -1) {
        if (window.location.toString().includes("en-us")) {

          // $(".nav-item > a span, .description p, .description ul li b, .ex-vat").each(function(){
            // var _this = $(this);
            // var text = $(this).text();

          
            document.querySelectorAll(".nav-item > a span, .description p, .description ul li b, .ex-vat").forEach(function (el) {
            var _this = this;
            var text = el.textContent;
              
            var re = {};
            re['Jewellery'] = "Jewelry";
            re['ex VAT'] = 'ex TAX';
            re['Personalised'] = 'Personalized';
            re['Colour'] = 'Color';
            re['accessorise'] = 'accessorize';
            re['categorise'] = 'categorize';
            re['centimetre'] = 'centimeter';
            re['centimetres'] = 'centimeters';
            re['centralise'] = 'centralize';
            re['centre'] = 'center';
            re['centred'] = 'centered';
            re['centrepiece'] = 'centerpiece';
            re['centrepieces'] = 'centerpieces';
            re['centres'] = 'centers';
            re['channelled'] = 'channeled';
            re['channelling'] = 'channeling';
            re['characterise'] = 'characterize';
            re['civilise'] = 'civilize';
            re['civilised'] = 'civilized';
            re['coloured'] = 'colored';
            re['colourful'] = 'colorful';
            re['colourless'] = 'colorless';
            re['colours'] = 'colors';
            re['computerise'] = 'computerize';
            re['cosy'] = 'cozy';
            re['criticise'] = 'criticize';
            re['digitise'] = 'digitize';
            re['dishevelled'] = 'disheveled';
            re['dramatise'] = 'dramatize';
            re['dramatised'] = 'dramatized';
            re['dramatises'] = 'dramatizes';
            re['dramatising'] = 'dramatizing';
            re['empathise'] = 'empathies';
            re['emphasise'] = 'emphasize';
            re['emphasise'] = 'emphasize';
            re['emphasised'] = 'emphasized';
            re['emphasises'] = 'emphasizes';
            re['emphasisin'] = 'emphasis in';
            re['endeavour'] = 'endeavor';
            re['endeavoured'] = 'endeavored';
            re['endeavouring'] = 'endeavoring';
            re['endeavours'] = 'endeavors';
            re['energise'] = 'energies';
            re['energised'] = 'energized';
            re['energises'] = 'energizes';
            re['energising'] = 'energizing';
            re['epitomise'] = 'epitomize';
            re['epitomised'] = 'epitomized';
            re['epitomises'] = 'epitomizes';
            re['equalise'] = 'equalize';
            re['equalised'] = 'equalized';
            re['familiarise'] = 'familiarize';
            re['familiarised'] = 'familiarized';
            re['familiarises'] = 'familiarizes';
            re['familiarising'] = 'familiarizing';
            re['fantasise'] = 'fantasies';
            re['fantasised'] = 'fantasized';
            re['fantasises'] = 'fantasizes';
            re['fantasising'] = 'fantasizing';
            re['favour'] = 'favor';
            re['favourable'] = 'favorable';
            re['favourably'] = 'favorably';
            re['favoured'] = 'favored';
            re['favouring'] = 'favoring';
            re['favourite'] = 'favorite';
            re['favourites'] = 'favorites';
            re['fictionalise'] = 'fictionalize';
            re['fictionalised'] = 'fictionalized';
            re['fictionalises'] = 'fictionalizes';
            re['fictionalising'] = 'fictionalizing';
            re['finalise'] = 'finalize';
            re['finalised'] = 'finalized';
            re['finalises'] = 'finalizes';
            re['finalising'] = 'finalizing';
            re['flavour'] = 'flavor';
            re['flavoured'] = 'flavored';
            re['flavouring'] = 'flavoring';
            re['flavourings'] = 'flavorings';
            re['flavourless'] = 'flavorless';
            re['flavours'] = 'flavors';
            re['formalise'] = 'formalize';
            re['formalised'] = 'formalized';
            re['formalises'] = 'formalizes';
            re['formalising'] = 'formalizing';
            re['fossilisation'] = 'fossilization';
            re['fossilise'] = 'fossilize';
            re['fossilised'] = 'fossilized';
            re['fossilises'] = 'fossilizes';
            re['fossilising'] = 'fossilizing';
            re['fulfil'] = 'fulfil';
            re['fulfilment'] = 'fulfilment';
            re['fulfils'] = 'fulfils';
            re['aeroplane'] = 'aero plane';
            re['aeroplanes'] = 'aero planes';
            re['glamour'] = 'glamour';
            re['grey'] = 'grey';
            re['honours'] = 'honors';
            re['honour'] = 'honor';
            re['humour'] = 'humor';
            re['idolise'] = 'idolize';
            re['instalment'] = 'instalment';
            re['instalments'] = 'instalments';
            re['kilogramme'] = 'kilogram me';
            re['kilogrammes'] = 'kilograms';
            re['kilometre'] = 'kilometer';
            re['licence'] = 'license';
            re['marvellous'] = 'marvelous';
            re['maximise'] = 'maximize';
            re['millimetre'] = 'millimeter';
            re['millimetres'] = 'millimeters';
            re['multicoloured'] = 'multicolored';
            re['normalise'] = 'normalize';
            re['optimise'] = 'optimize';
            re['optimised'] = 'optimized';
            re['optimises'] = 'optimizes';
            re['optimising'] = 'optimizing';
            re['organisation'] = 'organization';
            re['oxidisation'] = 'oxidization';
            re['oxidise'] = 'oxidize';
            re['oxidised'] = 'oxidized';
            re['oxidises'] = 'oxidizes';
            re['oxidising'] = 'oxidizing';
            re['prioritise'] = 'priorities';
            re['realise'] = 'realize';
            re['realised'] = 'realized';
            re['realises'] = 'realizes';
            re['realising'] = 'realizing';
            re['recognisable'] = 'recognizable';
            re['recognisably'] = 'recognizably';
            re['recognisance'] = 'recognizance';
            re['recognise'] = 'recognize';
            re['recognised'] = 'recognized';
            re['recognises'] = 'recognizes';
            re['recognising'] = 'recognizing';
            re['rumour'] = 'rumor';
            re['rumoured'] = 'rumored';
            re['rumours'] = 'rumors';
            re['sabre'] = 'saber';
            re['sabres'] = 'sabers';
            re['signalises'] = 'signalizes';
            re['socialise'] = 'socialize';
            re['sterilise'] = 'sterilize';
            re['sterilised'] = 'sterilized';
            re['steriliser'] = 'sterilizer';
            re['symbolise'] = 'symbolize';
            re['symbolised'] = 'symbolized';
            re['symbolises'] = 'symbolizes';
            re['symbolising'] = 'symbolizing';
            re['theatre'] = 'theatre';
            re['utilise'] = 'utilize';
            re['utilised'] = 'utilized';
            re['visualise'] = 'visualize';
            re['visualised'] = 'visualized';
            re['visualises'] = 'visualizes';
            re['visualising'] = 'visualizing';

            // $.each(re, function(key, value) {
            //   var find_text = new RegExp(key, 'ig');
            //   if(_this.text().match(find_text)) {
            //     var newText = _this.text().replace(find_text, value);
            //     _this.text(newText);
            //   }
            // });
            Object.keys(re).forEach(function (key) {
              var value = re[key];
              var findText = new RegExp(key, 'ig');
          
              if (_this.textContent.match(findText)) {
                  var newText = _this.textContent.replace(findText, value);
                  _this.textContent = newText;
              }
          });
            
          });
          
        
        }
      },2000);
  
  fetch('https://ipinfo.io/json')
   .then(response => response.json())
   .then(data => {
     console.log(data);
     var country_code = data.country;
      var country = data.city;
      console.log(country_code);
      //console.log(document.querySelector(".shipping-returns a").href);
      window.localStorage.setItem("UserCountry", "UK");
      if(country_code == "US"){
        window.localStorage.setItem("UserCountry", "US");
        //document.querySelector(".shipping-returns a").href = "/pages/shipping-returns-us";   
      } else if(country_code == "GB" || country_code == "UK"){
        window.localStorage.setItem("UserCountry", "UK");
        //document.querySelector(".shipping-returns a").href = "/pages/shipping-returns";
      } else if(country_code == "EU"){
        window.localStorage.setItem("UserCountry", "EU");
        //document.querySelector(".shipping-returns a").href = "/pages/shipping-returns-eu";
      } else if(country_code == "SE"){
        window.localStorage.setItem("UserCountry", "SE");
        //document.querySelector(".shipping-returns a").href = "/pages/shipping-returns-sweden";
      }
     
      if(country_code == "US"){
        console.log("US Country")

        // const country = document.querySelector('#Country');
        // const country_to_state = country.setAttribute('name','customer[note][State]');
        // const CountyPlaceholder = country.setAttribute('placeholder','State');
        // const CountyLabel = country.querySelector("[for='Country']");
        // // console.log(CountyLabel);
        // if(CountyLabel){
        //   const newCountryLabel = "State";
        //   CountyLabel.textContent(newCountryLabel);
        //   country.setAttribute('name',country_to_state);
        // }
        const StateUS = document.querySelector('.state-us');
        if(StateUS){StateUS.classList.remove('hide');}

        const postcode = document.querySelector('#Postcode');
        if(postcode){
          const postcode_to_zipcode = postcode.setAttribute('name','customer[note][Zipcode]');        
          const PostcodePlaceholder = postcode.setAttribute('placeholder','Zipcode*');
          const PostcodeLabel = postcode.querySelector("[for='Postcode']");
          console.log(PostcodeLabel);
          if(PostcodeLabel){
            const newPostcodeLabel = "Zipcode*";
            PostcodeLabel.textContent(newPostcodeLabel); 
            postcode.setAttribute('name',postcode_to_zipcode);
          }
        }  
    
        if(document.querySelector('#vat_number')){document.querySelector('#vat_number').remove();}
        if(document.querySelector('#uk-tc')){document.querySelector('#uk-tc').remove();}
        if(document.querySelector('.terms_append_from_here')){document.querySelector('.terms_append_from_here').classList.add('us_terms');}
        
      }else{
        console.log("Other Country");

        const classes_removes = document.querySelectorAll("#us-tc, .uk-hide");
        const Terms_Append_From_Here = document.querySelector(".terms_append_from_here");
        classes_removes.forEach(classes => {
          classes.remove();
        })
        if(document.querySelector('.no-uk-required')){
          document.querySelector('.no-uk-required').removeAttribute('required');
        }
        if(document.querySelector('.terms_append_here')){
          document.querySelector('.terms_append_here').append(Terms_Append_From_Here);
        }  

        var inputs = document.querySelectorAll('input[type=checkbox][id=CompanyNumberCheck], input[type=number][id=CompanyNumber]');
        inputs.forEach(function (input) {
          input.addEventListener('input', function () {
            inputs.forEach(function (otherInput) {
              if (otherInput !== input) {
                otherInput.required = !input.value.length;
              }
            });
          });
        });
      }
   })
   .catch(error => console.error('Error fetching data:', error))
});